<template>
  <div class="page">
    <h1>This is an Our Group page</h1>
  </div>
</template>
<script>
  export default {
    name: 'ourgroup',
  }
</script>